import { render, staticRenderFns } from "./Qbet.vue?vue&type=template&id=996feb6a&scoped=true"
import script from "./Qbet.vue?vue&type=script&lang=js"
export * from "./Qbet.vue?vue&type=script&lang=js"
import style0 from "./Qbet.vue?vue&type=style&index=0&id=996feb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996feb6a",
  null
  
)

export default component.exports